import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useCompBackgroundColor, useCompContext } from '@/context/__project__/CompContext'
import { useBuilderActionContextV2 } from '@/context/__project__/BuilderActionContextV2'

import { CompVideoWrapperCore } from '../core/video/wrapper'
import { CompVideo } from './CompVideo'

function CompVideoWrapper() {
  // infos
  const compContext = useCompContext()
  const { currentParentBg } = useCompBackgroundColor()
  const { activeLayer } = useActiveLayerContext()
  const infosProps = { ...compContext, activeLayer, currentParentBg }

  // action
  const actionContext = useBuilderActionContextV2()

  return (
    <CompVideoWrapperCore infos={infosProps} action={actionContext}>
      {(props) => <CompVideo {...props} />}
    </CompVideoWrapperCore>
  )
}


export default CompVideoWrapper